// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"Loader_loaderWrapper__gHh9U","circleWrapper":"Loader_circleWrapper__DOxCP"};